import type { ChildrenOnly } from '@studio/design-system/props';
import { useLazyRef, χref } from '@studio/react-utils/hooks';
import type { ReactElement } from 'react';
import type { Directive } from '../types.js';
import { Context } from './context.js';
import type { ListenerFn } from './types.js';

/** Command `<Provider>` component. */
export const Provider = ({ children }: ChildrenOnly): ReactElement => {
  const listenersRef = useLazyRef(() => new Set<ListenerFn>());

  // Stabilize handlers.
  const wiring = useLazyRef(() => ({
    add(listenerFn: ListenerFn): void {
      χref(listenersRef).add(listenerFn);
    },

    notify(directive: Directive): void {
      for (const listener of χref(listenersRef)) {
        listener(directive);
      }
    },

    remove(listenerFn: ListenerFn): void {
      χref(listenersRef).delete(listenerFn);
    }
  })).current;

  return <Context.Provider value={wiring}>{children}</Context.Provider>;
};
